import React from 'react'
import LoadingImage from "assets/images/nodata.png";
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';

const NotFound = () => {
  return (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      p={2}
      height="auto"
    >
      <img src={LoadingImage} style={{ borderRadius: "50%" }} width={250} alt="Loading..." />
      <SoftBox mt={1}>
        <SoftTypography variant="h6" fontWeight="bold" >
          No Data Found
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  )
}

export default NotFound;